import { createAction } from '@reduxjs/toolkit';

import { Device, DeviceValue, IParameter } from '../models/Device';
import { Ticket } from '../models/Ticket';

export const DEVICE_SLICE = 'device';

/* Device details */
export const getDeviceDetails = createAction<{
  unitId: string;
  refresh?: boolean;
}>(`${DEVICE_SLICE}/getDeviceDetails`);

export const setDeviceDetails = createAction<Device>(
  `${DEVICE_SLICE}/setDeviceDetails`
);

/* Parameter details */
export const getParameterDetails = createAction(
  `${DEVICE_SLICE}/getParameterDetails`
);

export const setParameterDetails = createAction<IParameter[]>(
  `${DEVICE_SLICE}/setParameterDetails`
);

/* Change parameters */
export const changeParameters = createAction<{
  ticket: Ticket;
  parameters: DeviceValue[];
}>(`${DEVICE_SLICE}/changeParameters`);
